import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { VoucherService } from "../../../accounts/voucher/shared/voucher.service";
import { Voucher } from "../../voucher/shared/voucher.model";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})
export class PrinttrailbalanceService {
  
  selectedVoucher: Voucher;

  constructor(private datePipe: DatePipe,
    private  voucherService : VoucherService, private httpClient: HttpClient) { }

  getBaseUrl() {

    return environment.baseUrl;
  }

  GenerateReport(rptSearchData: any) {

    this.voucherService.FetchLedgerReports(rptSearchData)
    .toPromise()
    .then(data => {
      this.ReportGenerateListHtml(data, rptSearchData, this.datePipe);
    })
    .catch(err => { console.log(err) });
  }

  ReportGenerateList(VoucherData : any, searchDate: any,datePipe: DatePipe) {

      function createHeaders(HeaderName) {

        var HeaderResult = [];
        for (var i = 0; i < HeaderName.length; i += 1) {
          if(i==0){
              HeaderResult.push({
                id: HeaderName[i],
                name: HeaderName[i],
                prompt: HeaderName[i],
                width: "240",
                align: "left",
                padding: 0,});}
          else if(i==1){
                  HeaderResult.push({
                    id: HeaderName[i],
                    name: HeaderName[i],
                    prompt: HeaderName[i],
                    width: "90",
                    align: "left",
                    padding: 0,});}
          else if(i==2){
              HeaderResult.push({
                id: HeaderName[i],
                name: HeaderName[i],
                prompt: HeaderName[i],
                width: "90",
                align: "left",
                padding: 0,
          });}
          else if(i==3){
            HeaderResult.push({
              id: HeaderName[i],
              name: HeaderName[i],
              prompt: HeaderName[i],
              width: "90",
              align: "left",
              padding: 0,
        });}
        else if(i==4 || i==5){
              HeaderResult.push({
                id: HeaderName[i],
                name: HeaderName[i],
                prompt: HeaderName[i],
                width: "90",
                align: "left",
                padding: 0,});}
        else{
              HeaderResult.push({
                id: HeaderName[i],
                name: HeaderName[i],
                prompt: HeaderName[i],
                width: "90",
                align: "left",
                padding: 0,});
            }
        }

      return HeaderResult;
      }

    var headers = createHeaders([
      "Ledger Name",
      "Opening Debit",
      "Opening Credit",
      "Transaction Debit",
      "Transaction Credit",
      "Closing Debit",
      "Closing Credit"
    ]);

    // Document of 210mm wide and 297mm high
    let pdf = new jsPDF('p', 'pt', 'A4');

    pdf.setProperties({
      title: 'Ledger',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });

    let todayDate = new Date();

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 40);  // 40 is the height
    pdf.text("Trial Balance Statement Between " + 
    datePipe.transform(searchDate.LedgerFromDate, 'dd-MM-yyyy').toString()
     + " and " +  
    datePipe.transform(searchDate.LedgerToDate, 'dd-MM-yyyy').toString(), 160, 60);
    pdf.setLineWidth(1);
    pdf.line(5, 70, 590, 70)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(8);   

    var generateData = function (VoucherData) {

      var result = [];
      var itemData = [{}];     
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < VoucherData.length; i += 1) {
        itemData[i] = {
          Id: VoucherData[i].Id.toString(),
          'Ledger Name': VoucherData[i].Name.toString(),
          'Opening Debit': VoucherData[i].OpeningDebitAmount.toString(),       
          'Opening Credit': VoucherData[i].OpeningCreditAmount.toString(),
          'Transaction Debit': VoucherData[i].TransactionDebitAmount.toString(),
          'Transaction Credit': VoucherData[i].TransactionCreditAmount.toString(),
          'Closing Debit': VoucherData[i].ClosingDebitAmount.toString(),
          'Closing Credit':  VoucherData[i].ClosingCreditAmount.toString(),
        };
      }

      for (var i = 0; i < VoucherData.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }
      return result;
    };

    pdf.table(5, 80,generateData(VoucherData), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');

  }

  ReportGenerateListHtml(VoucherData : any, searchDate: any, datePipe: DatePipe){

    let pdf = new jsPDF('l', 'pt', 'A4');

    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'
    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    pdf.addImage(img, 'png', 250, 20, 40, 40);
    let todayDate = new Date();

        // Top HEADER
        pdf.setTextColor(0, 0, 0);
        pdf.setFontSize(14);
        pdf.setFont('arial', 'normal');
        pdf.text("Society For Rural Improvements", 325, 20);  // 40 is the height
        pdf.text("Trial Balance Statement on ", 335, 40);
        pdf.text(datePipe.transform(searchDate.LedgerFromDate, 'dd-MM-yyyy').toString()
        + " and " +  
       datePipe.transform(searchDate.LedgerToDate, 'dd-MM-yyyy').toString(), 325, 60);
        pdf.setLineWidth(1);
        pdf.line(5, 70, 850, 70)
        // Top HEADER END 

    // list item to json array
    var itemData = [];
      for (var i = 0; i < VoucherData.length; i += 1) {
        console.log(VoucherData[i].LedgerName)
        itemData[i] = {
          'No': (i + 1).toString(),          
          'LedgerName': VoucherData[i].LedgerName != null ? (VoucherData[i].LedgerName.toString()) : " ",
          'OpeningDebit': VoucherData[i].OpeningDebit.toString(),
          'OpeningCredit': VoucherData[i].OpeningCredit.toString(),       
          'TransactionDebit': VoucherData[i].DrAmount.toString(),
          'TransactionCredit': VoucherData[i].CrAmount.toString(),
          'ClosingDebit': VoucherData[i].ClosingDebit.toString(),
          'ClosingCredit': VoucherData[i].ClosingCredit.toString(),
        };
      }

      var rows = [];
      // convert json array to Array
      itemData.forEach((element,index,array) => {
        rows.push([element.No, element.LedgerName, element.OpeningDebit, element.OpeningCredit,
          element.TransactionDebit, element.TransactionCredit, element.ClosingDebit, element.ClosingCredit
        ])
      });

    var columns = [
      {title: "No", dataKey: "No"},
      {title: "Ledger Name", dataKey: "LedgerName"},
      {title: "Opening Debit", dataKey: "OpeningDebit"},
      {title: "Opening Credit", dataKey: "OpeningCredit"},
      {title: "Transaction Debit", dataKey: "TransactionDebit"},
      {title: "Transaction Credit", dataKey: "TransactionCredit"},
      {title: "Closing Debit", dataKey: "ClosingDebit"},
      {title: "Closing Credit", dataKey: "ClosingCredit"},
      ];

    var body = rows;
    // New Header and Footer Data Include the table
    var y = 2;
    pdf.setLineWidth(y);
    
    autoTable(pdf,{
        body: body,
        columns: columns,
        startY: 80,
        margin: {
          left: 15,
        },
        styles: {font: 'helvetica', overflow: "ellipsize",},

        // foot:[[' ', 'Price total', '130000', '  ']],
        headStyles :{textColor: [255, 255, 255], minCellHeight:30,overflow: "linebreak",},
        footStyles :{textColor: [255, 255, 255],},
        
        theme: 'grid',
        columnStyles: {
            0: {halign: 'right', cellWidth: 40,},
            1: {halign: 'left', cellWidth: 280,},
            2: {halign: 'right', cellWidth: 80,},
            3: {halign: 'right', cellWidth: 85,},
            4: {halign: 'right',  cellWidth: 80,},
            5: {halign: 'right', cellWidth: 80,},
            6: {halign: 'right', cellWidth: 80,},
            7: {halign: 'right', cellWidth: 80,},
            8: {halign: 'right', cellWidth: 80,},
        },
})       
    // pdf.output('dataurlnewwindow');// commented on 20-03-2026 based on blank pdf on browser.
    // doc.save('Collection.pdf');  

    // The view logic
    const blob = pdf.output('blob')
    // create a temporary URL
    const url = URL.createObjectURL(blob);
    //open in a new tab(View Mode)
    const newWindow = window.open(url, '_blank');

    //safety check for pop-up blockers
    if(!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined'){
      alert('please disable your pop-up blocker to view the PDF.')
    }

    // We use a slight delay or wait for the window to unload
    if (newWindow) {
        newWindow.onload = () => {
            // Optional: Revoke after a delay to ensure Chrome has finished rendering
            setTimeout(() => {
                URL.revokeObjectURL(url);
                console.log("Memory cleared.");
            }, 1000);
    };
  }
  
}
  
}
